module.exports = __webpack_public_path__ + "assets/img/0-1.af6649ac.jpg";